export default [
  { name: 'telehealth.waiting', path: '/telehealth/:id', view: () => import('./waiting'), external: true }
];

export function nav(user) {
  return [
    { name: 'telehealth.waiting', navPath: 'Telehealth.Room' }
  ];
};